import { useResponsive } from 'app/hooks';
import { MobileControls, StyledMobileHeader } from './mobile-header.styled';
import { SVG } from 'app/pages/request-single-page/components-v4/svg';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { Text } from 'app/pages/request-single-page/components-v4/text';
import { Dropdown } from 'app/pages/request-single-page/components-v4/dropdown';
import { useFileDownload } from '../../../../hooks/use-file-download';
import { MediaItem } from '../../../../media.types';

type MobileHeaderProps = {
  file: MediaItem;
  current: number;
  total: number;
  onClose: () => void;
  visible: boolean;
};

export const MobileHeader = ({
  file,
  current,
  total,
  onClose,
  visible,
}: MobileHeaderProps) => {
  const { viewport } = useResponsive();
  const downloadFile = useFileDownload();

  return (
    <StyledMobileHeader $visible={visible}>
      <MobileControls>
        <SVG
          src={Icons.Chevron}
          action={onClose}
          props={{ size: '24px', deg: 90 }}
        />

        <Text variant="heading-3" truncate align="center" style={{ flex: 1 }}>
          {file.name}
        </Text>

        <Dropdown.Root>
          <Dropdown.Trigger>
            <div>
              <SVG src={Icons.Dots} props={{ size: '24px' }} />
            </div>
          </Dropdown.Trigger>

          <Dropdown.Content modal align="end">
            <Dropdown.Item
              disabled={
                downloadFile.progress[file.id]?.status === 'downloading'
              }
              onSelect={() => downloadFile.call(file)}
            >
              <Dropdown.Label>Скачать</Dropdown.Label>
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Root>
      </MobileControls>

      <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
        {current + 1} из {total}
      </Text>
    </StyledMobileHeader>
  );
};
